/**
 * @description simple hook that queries the backend to determine if the user can administrate this view or not.
 *   It assumes they cannot until the backend is successfully queried.
 */

import { useQuery } from '@tanstack/react-query';

import fetchCanAdmin from '../queries/fetchCanAdmin';

const useCanAdmin = () => {
  const { data } = useQuery(fetchCanAdmin());

  return data?.allowed ?? false;
};

export default useCanAdmin;
